<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiFolderZip } from "@mdi/js";
export default {
  name: "MdiFolderZip",
  data() {
    return {
      svgPath: mdiFolderZip,
    };
  },
};
</script>
